import { Component, OnInit, ElementRef } from '@angular/core';
import {MeService} from '../../services/me.service';
import {User} from '../../models/user';
import {ApiService} from '../../api/api.service';
import * as _ from 'lodash';
import {TranslateService} from '@ngx-translate/core';
import {LoaderService} from '../../api/loader.service';
import moment from 'moment';
import html2canvas from 'html2canvas';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {IamService} from '../../services/iam.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    providers: [MessageService],
    standalone: false
})
export class DashboardComponent implements OnInit {
  product_names: any;
  services: any;
  category_data: any;
  country_names: any;
  bills: any;
  saleitems: any;
  cases: any;
  case_weekdays: any = [];
  services_graph_options: any = [];
  options1: any;
  options2: any = [];
  options3: any;
  options4: any;
  servicerating_options: any;
  case_options: any;
  backgroundColors: string[];

  utcoffset: number;
  service_country_id: number = null;
  service_product_id: number = null;
  service_sponsor_id: number = null;
  service_provider_id: number = null;
  service_category_id: number = null;
  service_service_id: number = null;
  service_date_start: Date;
  service_date_end: Date;

  financial_country_id: number = null;
  financial_product_id: number = null;
  financial_sponsor_id: number = null;
  financial_provider_id: number = null;
  financial_category_id: number = null;
  financial_service_id: number = null;
  financial_date_start: Date;
  financial_date_end: Date;

  attention_date_start: Date;
  attention_date_end: Date;

  case_country_id: number = null;
  case_product_id: number = null;
  case_category_id: number = null;
  case_service_id: number = null;
  case_provider_id: number = null;
  case_date_start: Date;
  case_date_end: Date;

  experience_country_id: number = null;
  experience_product_id: number = null;
  experience_sponsor_id: number = null;
  experience_provider_id: number = null;
  experience_category_id: number = null;
  experience_service_id: number = null;
  experience_date_start: Date;
  experience_date_end: Date;

  financial_currency_symbol: string = null;
  labels: any;
  vial_services_pie: any;
  vial_services_bar: any;
  medica_services_pie: any;
  medica_services_bar: any;
  hogar_services_pie: any;
  hogar_services_bar: any;
  bcx_operatordata_pie: any;
  bcx_operatordata_bar: any;
  bcx_providerdata_pie: any;
  bcx_providerdata_bar: any;
  ces_data_pie: any;
  ces_data_bar: any;
  nps_data_pie: any;
  nps_data_bar: any;
  contact_data_pie: any;
  contact_data_bar: any;
  service_rating_data: any;
  cases_label: string;
  nps: number;

  // Colors for graphs
  red_color: string;
  green_color: string;
  neutral_color: string;

  // Dates for labels
  today: any;
  yesterday: any;
  this_month: any;
  last_day_month: any;

  tooltipset: any;
  bartooltipset: any;
  dateoption = {};

  months = [];
  chart_format: boolean[];
  download_chartname: string = '';
  showDownloadDialog = false;
  downloadItems = [
    {value: 1, name: 'Image'},
    {value: 2, name: 'Report'}
  ];
  fileType = 'csv';
  downloadItem: any;
  service_filter: any = {};
  experience_filter: any = {};
  case_filter: any = {};
  attention_filter: any = {};
  financial_filter: any = {};

  iAm = null;

  //providers
  providers_graph_options: any = [];
  providers_data_pie: any;
  providers_data_bar: any;

  constructor(private loaderService: LoaderService,
              private me: MeService,
              private api: ApiService,
              private translate: TranslateService,
              public el: ElementRef,
              private router: Router,
              private iam: IamService,
              private messageService: MessageService)
  {
    this.iAm = iam;
    this.utcoffset = new Date().getTimezoneOffset();
    this.chart_format = Array(13).fill(false);
    this.tooltipset = {
      displayColors: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return;
        },
        title: function (tooltipItems, data) {
          // Return value for title
          const allData = data.datasets[tooltipItems[0].datasetIndex].data;
          const tooltipLabel = data.labels[tooltipItems[0].index];
          const tooltipData = allData[tooltipItems[0].index];
          let total = 0;
          for (let i in allData) {
            total += allData[i];
          }
          let tooltipPercentage = ((tooltipData / total) * 100);
          tooltipPercentage = Math.round(tooltipPercentage * 10) / 10;
          return tooltipLabel + ': ' + tooltipData + ' (' + tooltipPercentage + '%)';
        },

      },
      titleFontSize: 12,
      titleFontColor: '#FFF',
    };

    this.bartooltipset = {
      displayColors: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return;
        },
        title: function (tooltipItems, data) {
          // Return value for title
          const datasets = data.datasets;
          const individualdata = datasets[tooltipItems[0].datasetIndex].data;
          const tooltipLabel = datasets[tooltipItems[0].datasetIndex].label;
          const tooltipData = parseFloat(individualdata[tooltipItems[0].index]);
          let total = 0;
          for (let i in datasets) {
            total += datasets[i].data[tooltipItems[0].index];
          }
          let tooltipPercentage = ((tooltipData / total) * 100);
          tooltipPercentage = Math.round(tooltipPercentage * 10) / 10;
          return tooltipLabel + ': ' + tooltipData + ' (' + tooltipPercentage + '%)';
        },

      },
      titleFontSize: 12,
      titleFontColor: '#FFF',
    };

    this.services_graph_options[0] = {
      legend: {
        display: false,
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      tooltips: this.tooltipset
    };
    this.services_graph_options[1] = {
      scales:
        {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: true,
            ticks: {
              min: 0,
              // stepSize: 1
            }
          }]
        },
      legend: {
        display: false,
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      tooltips: this.tooltipset
    };
    this.case_options = {
      legend: {
        position: 'bottom',
      },
      tooltips: {
        displayColors: false,
        callbacks: {
          label: function (tooltipItem, data) {
            return;
          },
          title: ((tooltipItems, data) => {
            const allData = data.datasets[tooltipItems[0].datasetIndex].data;
            const label_day = new Date(data.datasets[tooltipItems[0].datasetIndex].labels[tooltipItems[0].index]);
            // 
            // 
            // 
            const month = this.months[label_day.getMonth()];
            const day = label_day.getDate();
            const tooltipData = allData[tooltipItems[0].index];
            return month + ', ' + day + ': ' + tooltipData;
          }),

        },
        titleFontSize: 12,
        titleFontColor: '#FFF',
      }
    };
    this.options1 = {
      legend: {
        position: 'bottom',
      },
      tooltips: this.tooltipset
    };
    this.options2[0] = {
      legend: {
        position: 'bottom',
      },
      'onClick': ((evt, item) => {
        if (item[0])
          this.gocase(item[0]);
      }),
      tooltips: this.tooltipset
    };
    this.options2[1] = {
      scales:
        {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: true,
            ticks: {
              min: 0,
              // stepSize: 1
            }
          }]
        },
      legend: {
        position: 'bottom',
      },
      // 'onClick' : ((evt, item) => {
      //             if (item[0])
      //               this.gocase(item[0]);
      //         }),
      tooltips: this.bartooltipset
    };
    this.options3 = {
      scales:
        {
          xAxes: [{
            display: false
          }]
        },
      legend: {
        display: false
      },
      tooltips: {
        displayColors: false,
        callbacks: {
          label: function (tooltipItem, data) {
            return;
          },
          title: function (tooltipItems, data) {
            // Return value for title
            const allData = data.datasets[tooltipItems[0].datasetIndex].data;
            const tooltipLabel = data.labels[tooltipItems[0].index];
            const tooltipData = parseFloat(allData[tooltipItems[0].index]);
            const withCommas = tooltipData.toLocaleString();
            return tooltipLabel + ': ' + withCommas;
          },

        },
        titleFontSize: 12,
        titleFontColor: '#FFF',
      }
    };
    this.servicerating_options = {
      scales:
        {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: true,
            ticks: {
              min: 0,
              max: 10,
              stepSize: 1
            }
          }]
        },
      legend: {
        display: false
      },
      tooltips: {
        displayColors: false,
        callbacks: {
          label: function (tooltipItem, data) {
            return;
          },
          title: function (tooltipItems, data) {
            // Return value for title
            const allData = data.datasets[tooltipItems[0].datasetIndex].data;
            const tooltipLabel = data.labels[tooltipItems[0].index];
            let tooltipData = parseFloat(allData[tooltipItems[0].index]);
            tooltipData = Math.round(tooltipData * 10) / 10;
            return tooltipLabel + ': ' + tooltipData;
          },

        },
        titleFontSize: 12,
        titleFontColor: '#FFF',
      }
    };
    this.options4 = {
      legend: {
        display: true,
        position: 'bottom'
      },
      tooltips: {
        displayColors: false,
        callbacks: {
          label: function (tooltipItem, data) {
            return;
          },
          title: function (tooltipItems, data) {
            // Return value for title
            const allData = data.datasets[tooltipItems[0].datasetIndex].data;
            const tooltipLabel = data.datasets[tooltipItems[0].datasetIndex].label;
            const tooltipData = allData[tooltipItems[0].index];
            return tooltipLabel + ': ' + tooltipData.toLocaleString();
          },
        },
        titleFontSize: 12,
        titleFontColor: '#FFF',
      }
    };

    this.providers_graph_options[0] = {
      legend: {
        display: true,
        position: 'bottom',
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      tooltips: this.tooltipset
    };
    this.providers_graph_options[1] = {
      scales:
        {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: true,
            ticks: {
              min: 0,              
            }
          }]
        },
      legend: {
        position: 'bottom',
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      tooltips: this.bartooltipset
    };

  }

  getMe(): User {
    return this.me.user;
  }

  ngOnInit() {
    // If user has assistance_salesman role, redirect him to sales dashboard
    if (this.iam.specialRole(['assistance_salesman'])){
      // Redirect to salesman page
      this.router.navigate(['/admin/assistance/sales/dashboard']);
    }

    this.loaderService.display(true);
    this.backgroundColors = [
      '#9edae5',
      '#17becf',
      '#dbdb8d',
      '#bcbd22',
      '#c7c7c7',
      '#7f7f7f',
      '#f7b6d2',
      '#e377c2',
      '#c49c94',
      '#8c564b',
      '#c5b0d5',
      '#9467bd',
      '#ff9896',
      '#d62728',
      '#98df8a',
      '#2ca02c',
      '#ffbb78',
      '#ff7f0e',
      '#aec7e8',
      '#1f77b4'
    ];

    this.labels = {
      'Price': 'Price',
      'Income': 'Income',
      'Planned': 'Planned',
      'Paid': 'Paid',
      'Last Month': 'Last Month',
      'Current Month': 'Current Month',
      'January': 'January',
      'February': 'February',
      'March': 'March',
      'April': 'April',
      'May': 'May',
      'June': 'June',
      'July': 'July',
      'August': 'August',
      'September': 'September',
      'October': 'October',
      'November': 'November',
      'December': 'December',
      'to': 'to',
      'Promoters': 'Promoters',
      'Liabilities': 'Liabilities',
      'Detractors': 'Detractors',
      'Excellent': 'Excellent',
      'Non-Excellent': 'Non-Excellent',
      'Answered': 'Answered',
      'Didn\'t Answer': 'Didn\'t Answer',
      'Today': 'Today',
      'Yesterday': 'Yesterday',
      'Last 7 Days': 'Last 7 Days',
      'Last 30 Days': 'Last 30 Days',
      'This Month': 'This Month',
      'Custom Range': 'Custom Range',
      'Apply': 'Apply',
      'Cancel': 'Cancel',
      'Su': 'Su',
      'Mo': 'Mo',
      'Tu': 'Tu',
      'We': 'We',
      'Th': 'Th',
      'Fr': 'Fr',
      'Sa': 'Sa',
      'Active': 'Active',
      'Pending': 'Pending'
    };

    this.months[0] = this.labels['January'].substring(0, 3);
    this.months[1] = this.labels['February'].substring(0, 3);
    this.months[2] = this.labels['March'].substring(0, 3);
    this.months[3] = this.labels['April'].substring(0, 3);
    this.months[4] = this.labels['May'].substring(0, 3);
    this.months[5] = this.labels['June'].substring(0, 3);
    this.months[6] = this.labels['July'].substring(0, 3);
    this.months[7] = this.labels['August'].substring(0, 3);
    this.months[8] = this.labels['September'].substring(0, 3);
    this.months[9] = this.labels['October'].substring(0, 3);
    this.months[10] = this.labels['November'].substring(0, 3);
    this.months[11] = this.labels['December'].substring(0, 3);

    this.translateLabels();

    // Start NPS numbers
    this.nps = 0;

    // Set colors
    this.green_color = '#6FF254';
    this.neutral_color = '#7CB0F4';
    this.red_color = '#FF6E6B';

    // Set dates for labels
    this.today = new Date();
    this.yesterday = new Date();
    this.yesterday.setDate(this.yesterday.getDate() - 1);
    const date = new Date();
    this.this_month = new Date(date.getFullYear(), date.getMonth(), 1);
    this.last_day_month = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.service_date_start = this.this_month;
    this.service_date_end = this.last_day_month;
    this.financial_date_start = this.this_month;
    this.financial_date_end = this.last_day_month;
    this.attention_date_start = this.this_month;
    this.attention_date_end = this.last_day_month;
    this.case_date_start = new Date(date.getTime() - 8 * 7 * 24 * 3600 * 1000); // ago 8 weeks
    this.case_date_end = date;

    this.experience_date_start = this.this_month;
    this.experience_date_end = this.last_day_month;

    this.setCasesDays();

    this.setService_graph();
    this.setFinancial_graph();
    this.setAttention_graph();
    this.setCase_graph();
    this.setExperience_graph();
    this.setProviders_graph();
    this.loaderService.display(false);


  }

  gocase(item) {

    if (!item._chart.config.data.index)
      return;

    let bcx_operator = null;
    let bcx_provider = null;
    let ces_data = null;
    let nps_data = null;
    let contact_data = null;
    if (item._chart.config.data.index === 'bcx_oper') {
      // bcx_operator = item._view.label;
      bcx_operator = item._index;
    } else if (item._chart.config.data.index === 'bcx_pro') {
      bcx_provider = item._index;
    } else if (item._chart.config.data.index === 'ces') {
      ces_data = item._index;
    } else if (item._chart.config.data.index === 'nps') {
      nps_data = item._index;
    } else if (item._chart.config.data.index === 'contact') {
      contact_data = item._index;
    }

    const filter = {
      'country_id': this.experience_country_id,
      'sponsor_id': this.experience_sponsor_id,
      'assistance_id': this.experience_product_id,
      'provider_id': this.experience_provider_id,
      'category_id': this.experience_category_id,
      'service_id': this.experience_service_id,
      'dashboard_flag': true,
      'from_date': this.date_to_str(this.experience_date_start),
      'to_date': this.date_to_str(this.experience_date_end),
      'bcx_operator': bcx_operator,
      'bcx_provider': bcx_provider,
      'ces_data': ces_data,
      'nps_data': nps_data,
      'contact_data': contact_data
    };
    this.router.navigate(['admin/assistance/cases'], {queryParams: filter});
  }

  downloaddata(chartname) {
    this.download_chartname = chartname;
    if (chartname === 'Expenses vs Income' || chartname === 'Categories' || chartname === 'assistance_providers') {
      this.downloadItems = [
        {value: 1, name: 'Image'}];
    } else {
      this.downloadItems = [
        {value: 1, name: 'Image'},
        {value: 2, name: 'Report'}];
    }

    this.downloadItem = 1; // default downloaditem is image
    this.showDownloadDialog = true;
  }

  onDownload() {
    if (this.downloadItem === 1)
      this.download_image();
    else if (this.downloadItem === 2)
      this.download_report();
    this.showDownloadDialog = false;
  }

  onDownloadCancel() {
    this.showDownloadDialog = false;
  }

  download_image() {
    let renderdiv: any;
    const chart_name = JSON.parse(JSON.stringify(this.download_chartname));
    const chart_id = chart_name.split(' ').join('_');
    renderdiv = this.el.nativeElement.querySelector('#' + chart_id);
    const options = {allowTaint: true, useCORS: true, async: true,
              removeContainer:	true, letterRendering: false };
    html2canvas(renderdiv, options)
      .then((canvas) => {
        const ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = false;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.font = '4em sans-serif';
        const base64image = canvas.toDataURL('image/png');
        const a = document.createElement('a');
          a.href = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
          a.download = this.download_chartname + '.png';
          document.body.appendChild(a);
          a.click();
        // document.body.removeChild(a);
      })
      .catch(err => {
        
      });
  }

  download_report() {
    this.messageService.clear()
    const filter = this.setDownload_filter(this.download_chartname);
    this.api.assistancecases.createReportAttachment({file_type: this.fileType, filter: filter}).promise()
      .then(report => {
        this.messageService.add({severity: 'info', summary: 'Info', detail: `Report ${report.id} added to queue`});
      })
      .catch(e => {
        this.messageService.add({severity: 'error', summary: 'Error', detail: `Report Data Error: ${e.statusText}`});
      });
  }

  setDate_range(range, graph_name) {
    if (graph_name === 'service') {
      this.service_date_start = range.start._d;
      this.service_date_end = range.end._d;
      this.setService_graph();
    } else if (graph_name === 'financial') {
      this.financial_date_start = range.start._d;
      this.financial_date_end = range.end._d;
      this.setFinancial_graph();
    } else if (graph_name === 'attention') {
      this.attention_date_start = range.start._d;
      this.attention_date_end = range.end._d;
      this.setAttention_graph();
    } else if (graph_name === 'experience') {
      this.experience_date_start = range.start._d;
      this.experience_date_end = range.end._d;
      this.setExperience_graph();
    }
  }

  setService_graph() {
    this.service_filter = {
      'country_id': this.service_country_id,
      'sponsor_id': this.service_sponsor_id,
      'assistance_id': this.service_product_id,
      'provider_id': this.service_provider_id,
      'category_id': this.service_category_id,
      'service_id': this.service_service_id,
      'from_date': this.date_to_str(this.service_date_start),
      'to_date': this.date_to_str(this.service_date_end),
      'utcoffset': this.utcoffset
    };
    this.api.assistancecases.getitems().filter(this.service_filter).promise()
      .then(caseitems => {
       
        this.draw_Sponsors(caseitems[0]);
        this.draw_Services(caseitems[1]);
        this.draw_Categories(caseitems[2]);
        this.draw_Countries(caseitems[3]);
      });

  }

  setExperience_graph() {
    this.experience_filter = {
      'country_id': this.experience_country_id,
      'sponsor_id': this.experience_sponsor_id,
      'assistance_id': this.experience_product_id,
      'provider_id': this.experience_provider_id,
      'category_id': this.experience_category_id,
      'service_id': this.experience_service_id,
      'from_date': this.date_to_str(this.experience_date_start),
      'to_date': this.date_to_str(this.experience_date_end),
      'utcoffset': this.utcoffset
    };
    this.api.assistancecases.getcaseratings().filter(this.experience_filter).promise()
      .then(items => {
        this.draw_Experience_graph(items);
      });
    this.api.assistancecases.getserviceratings().filter(this.experience_filter).promise()
      .then(items => {
        this.setServiceratings(items);
      });
  }

  setFinancial_graph() {
    this.financial_filter = {
      'country_id': this.financial_country_id,
      'sponsor_id': this.financial_sponsor_id,
      'assistance_id': this.financial_product_id,
      'provider_id': this.financial_provider_id,
      'category_id': this.financial_category_id,
      'service_id': this.financial_service_id,
      'from_date': this.date_to_str(this.financial_date_start),
      'to_date': this.date_to_str(this.financial_date_end),
      'utcoffset': this.utcoffset
    };
    this.api.assistancecases.getbills().filter(this.financial_filter).promise()
      .then(items => {
        this.draw_financial_category(items);
      });
  }

  setAttention_graph() {
    this.attention_filter = {
      'from_date': this.date_to_str(this.attention_date_start),
      'to_date': this.date_to_str(this.attention_date_end),
      'utcoffset': this.utcoffset
    };
    this.api.assistancecases.getcaseservicetimes().filter(this.attention_filter).promise()
      .then(servicetimes => {
        this.draw_Attention(servicetimes);
      });
  }

  setCase_graph() {
    this.case_filter = {
      'country_id': this.case_country_id,
      'assistance_id': this.case_product_id,
      'provider_id': this.case_provider_id,
      'category_id': this.case_category_id,
      'service_id': this.case_service_id
    };
    this.api.assistancecases.getcaseamount().filter(this.case_filter).promise()
      .then(items => {
        this.draw_Cases(items);
      });
  }

  setProviders_graph() {
    //active
    this.api.assistanceProviders.get().filter({status: 1}).promise()
      .then(activeProviders => {
        //pending
        this.api.assistanceProviders.get().filter({status: 3}).promise()
          .then(pendingProviders => {
            this.draw_AssistanceProviders(activeProviders, pendingProviders);
          });
      });    
  }

  draw_Sponsors(items) {
    let label = [];
    let data = [];
    items.forEach(item => {
      if (item[0] === null)
        label.push('Other');
      else
        label.push(item[0]);
      data.push(item[1]);
    });

    // Get colors for graph
    const bgColors = this.getColors(data.length);
    this.product_names = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  draw_Services(items) {
    let label = [];
    let data = [];
    items.forEach(item => {
      label.push(item[0]);
      data.push(item[1]);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.services = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  draw_Categories(items) {
    let label = [];
    let data = [];
    items.forEach(item => {
      label.push(item[0]);
      data.push(item[1]);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.category_data = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  draw_Countries(items) {
    let label = [];
    let data = [];
    items.forEach(item => {
      label.push(item[0]);
      data.push(item[1]);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);
    
    this.country_names = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };

  }

  draw_Cases(items) {
    this.cases_label = ' ' + this.months[this.case_date_start.getMonth()] + ' '
      + 'to' + ' ' + this.months[this.case_date_end.getMonth()];
    // 
    this.cases = {
      labels: this.case_weekdays,
      datasets: [
        {
          label: 'Last',
          labels: items.data[0],
          data: items.data[1],
          fill: false,
          borderColor: '#565656'
        },
        {
          label: 'Current',
          labels: items.total[0],
          data: items.total[1],
          fill: false,
          borderColor: '#4bc0c0'
        }
      ]
    };
  }

  draw_Attention(items) {
    const datas = items;
    let vial_data: number[];
    vial_data = Array(2).fill(0);
    let medica_data: number[];
    medica_data = Array(2).fill(0);
    let hogar_data: number[];
    hogar_data = Array(2).fill(0);

    datas.forEach(d => {
      const timedelta = (new Date(d[1].datetime).getTime() - new Date(d[0].date_start).getTime()) / 1000;
      const service_name = d[1].service.name;
      if (service_name === 'Grua' || service_name === 'Cambio de llanta' ||
        service_name === 'Paso de corriente' || service_name === 'Envío de combustible' ||
        service_name === 'Cerrajería Vehicular') {
        if (timedelta < 40 * 60)
          vial_data[0]++;
        else
          vial_data[1]++;
      } else if (service_name === 'Ambulancia' || service_name === 'Médica domiciliar') {
        if (timedelta < 30 * 60)
          medica_data[0]++;
        else
          medica_data[1]++;
      } else if (service_name === 'Plomería' || service_name === 'Electricidad' ||
        service_name === 'Cerrajería domiciliar' || service_name === 'Vidriería') {
        if (timedelta < 40 * 60)
          hogar_data[0]++;
        else
          hogar_data[1]++;
      }

    });

    const twoColors = [
      this.green_color,
      this.red_color
    ];
    this.vial_services_pie = {
      labels: ['< 40 min', '> 40 min'],
      datasets: [
        {
          data: vial_data,
          backgroundColor: twoColors,
          hoverBackgroundColor: twoColors,
          borderWidth: 0
        }
      ]
    };

    this.vial_services_bar = {
      datasets: [
        {
          label: '< 40 min',
          data: [vial_data[0]],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: '> 40 min',
          data: [vial_data[1]],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ]
    };

    this.medica_services_pie = {
      labels: ['< 30 min', '> 30 min'],
      datasets: [
        {
          data: medica_data,
          backgroundColor: twoColors,
          hoverBackgroundColor: twoColors,
          borderWidth: 0
        }
      ]
    };

    this.medica_services_bar = {
      datasets: [
        {
          label: '< 30 min',
          data: [medica_data[0]],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: '> 30 min',
          data: [medica_data[1]],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ]
    };

    this.hogar_services_pie = {
      labels: ['< 40 min', '> 40 min'],
      datasets: [
        {
          data: hogar_data,
          backgroundColor: twoColors,
          hoverBackgroundColor: twoColors,
          borderWidth: 0
        }
      ]
    };

    this.hogar_services_bar = {
      datasets: [
        {
          label: '< 40 min',
          data: [hogar_data[0]],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: '> 40 min',
          data: [hogar_data[1]],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ]
    };
  }

  setServiceratings(items) {
    const label = [];
    const data = [];
    items.forEach(item => {
      label.push(item[0]);
      data.push(item[1]);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);
    this.service_rating_data = {
      labels: label,
      datasets: [
        {
          // label: 'My First dataset',
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: [],
          data: data
        }
      ],
    };
  }

  draw_Experience_graph(items) {
    const twoColors = [
      this.green_color,
      this.red_color
    ];

    this.bcx_operatordata_bar = {
      datasets: [
        {
          label: this.labels['Excellent'],
          data: [items[0][0]],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: this.labels['Non-Excellent'],
          data: [items[0][1]],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ],
      index: 'bcx_oper'
    };

    this.bcx_operatordata_pie = {
      labels: [this.labels['Excellent'], this.labels['Non-Excellent']],
      datasets: [
        {
          data: items[0],
          backgroundColor: twoColors,
          hoverBackgroundColor: twoColors,
          borderWidth: 0
        }
      ],
      index: 'bcx_oper'
    };


    this.bcx_providerdata_bar = {
      datasets: [
        {
          label: this.labels['Excellent'],
          data: [items[1][0]],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: this.labels['Non-Excellent'],
          data: [items[1][1]],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ],
      index: 'bcx_pro'
    };

    this.bcx_providerdata_pie = {
      labels: [this.labels['Excellent'], this.labels['Non-Excellent']],
      datasets: [
        {
          data: items[1],
          backgroundColor: twoColors,
          hoverBackgroundColor: twoColors,
          borderWidth: 0
        }
      ],
      index: 'bcx_pro'
    };

    this.ces_data_bar = {
      datasets: [
        {
          label: this.labels['Excellent'],
          data: [items[2][0]],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: this.labels['Non-Excellent'],
          data: [items[2][1]],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ],
      index: 'ces'
    };

    this.ces_data_pie = {
      labels: [this.labels['Excellent'], this.labels['Non-Excellent']],
      datasets: [
        {
          data: items[2],
          backgroundColor: twoColors,
          hoverBackgroundColor: twoColors,
          borderWidth: 0
        }
      ],
      index: 'ces'
    };


    // Set value of nps
    const npsInfo = items[3];
    if (npsInfo.length >= 3) {
      const total = npsInfo[0] + npsInfo[1] + npsInfo[2];
      if (total === 0)
        this.nps = 0;
      else
        this.nps = (npsInfo[0] - npsInfo[2]) * 100 / total;
      this.nps = Math.round(this.nps * 10) / 10;
    }

    const three_colors = [
      this.green_color,
      this.neutral_color,
      this.red_color
    ];

    this.nps_data_bar = {
      datasets: [
        {
          label: this.labels['Promoters'],
          data: [npsInfo[0]],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: this.labels['Liabilities'],
          data: [npsInfo[1]],
          backgroundColor: this.neutral_color,
          borderColor: '#7CB0F4',
          borderWidth: 0
        },
        {
          label: this.labels['Detractors'],
          data: [npsInfo[2]],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ],
      index: 'nps'
    };

    this.nps_data_pie = {
      labels: [
        this.labels['Promoters'],
        this.labels['Liabilities'],
        this.labels['Detractors']
      ],
      datasets: [
        {
          data: npsInfo,
          backgroundColor: three_colors,
          hoverBackgroundColor: three_colors,
          borderWidth: 0
        }
      ],
      index: 'nps'
    };

    this.contact_data_bar = {
      datasets: [
        {
          label: this.labels['Answered'],
          data: [items[4][0]],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: this.labels['Didn\'t Answer'],
          data: [items[4][1]],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ],
      index: 'contact'
    };

    this.contact_data_pie = {
      labels: [this.labels['Answered'], this.labels['Didn\'t Answer']],
      datasets: [
        {
          data: items[4],
          backgroundColor: twoColors,
          hoverBackgroundColor: twoColors,
          borderWidth: 0
        }
      ],
      index: 'contact'
    };
  }

  draw_financial_category(items) {
    this.bills = {
      labels: _.keysIn(items),
      datasets: [
        {
          label: this.labels['Price'] + ' ' + '(' + this.financial_currency_symbol + ')',
          backgroundColor: '#42A5F5',
          borderColor: '#1E88E5',
          data: _.valuesIn(items)
        },
      ]
    };
  }

  draw_financial_income(items) {
    let label1, label2, label3: any;
    label1 = this.labels['Income'];
    label2 = this.labels['Planned'];
    label3 = this.labels['Paid'];
    if (this.financial_currency_symbol) {
      label1 += ' ' + '(' + this.financial_currency_symbol + ')';
      label2 += ' ' + '(' + this.financial_currency_symbol + ')';
      label3 += ' ' + '(' + this.financial_currency_symbol + ')';
    }

    this.saleitems = {
      datasets: [
        {
          label: label1,
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          data: [items[0]]
        },
        {
          label: label2,
          backgroundColor: this.neutral_color,
          borderColor: '#1E88E5',
          data: [items[1]]
        },
        {
          label: label3,
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          data: [items[2]]
        },
      ]
    };
  }

  draw_AssistanceProviders(activeProviders, pendingProviders) {
    this.providers_data_bar = {
      datasets: [
        {
          label: this.labels['Active'],
          data: [activeProviders.total],
          backgroundColor: this.green_color,
          borderColor: '#5ab942',
          borderWidth: 0
        },
        {
          label: this.labels['Pending'],
          data: [pendingProviders.total],
          backgroundColor: this.red_color,
          borderColor: '#BD0E0F',
          borderWidth: 0
        }
      ],
      index: 'assistance_provider'
    };

    this.providers_data_pie = {
      labels: [this.labels['Active'], this.labels['Pending']],
      datasets: [
        {
          data: [activeProviders.total, pendingProviders.total],
          backgroundColor: [
            this.green_color,
            this.red_color
          ],
          hoverBackgroundColor: [
            this.green_color,
            this.red_color
          ],
          borderWidth: 0
        }
      ],
      index: 'assistance_provider'
    };
  }

  onFilters(filterdata) {
    if (filterdata.graph_id === 'service') {
      this.service_country_id = filterdata.country;
      this.service_product_id = filterdata.product;
      this.service_sponsor_id = filterdata.sponsor;
      this.service_provider_id = filterdata.provider;
      this.service_category_id = filterdata.category;
      this.service_service_id = filterdata.service;
      this.setService_graph();
    } else if (filterdata.graph_id === 'financial') {
      this.financial_country_id = filterdata.country;
      this.financial_currency_symbol = filterdata.symbol;
      this.financial_product_id = filterdata.product;
      this.financial_sponsor_id = filterdata.sponsor;
      this.financial_provider_id = filterdata.provider;
      this.financial_category_id = filterdata.category;
      this.financial_service_id = filterdata.service;
      this.setFinancial_graph();
    } else if (filterdata.graph_id === 'case') {
      this.case_country_id = filterdata.country;
      this.case_product_id = filterdata.product;
      this.case_provider_id = filterdata.provider;
      this.case_category_id = filterdata.category;
      this.case_service_id = filterdata.service;
      this.setCase_graph();
    } else if (filterdata.graph_id === 'experience') {
      this.experience_country_id = filterdata.country;
      this.experience_product_id = filterdata.product;
      this.experience_sponsor_id = filterdata.sponsor;
      this.experience_provider_id = filterdata.provider;
      this.experience_category_id = filterdata.category;
      this.experience_service_id = filterdata.service;
      this.setExperience_graph();
    }

  }

  translateLabels() {
    let lblTexts = [];

    for (let key in this.labels) {
      lblTexts.push(this.labels[key]);
    }

    this.translate.get(lblTexts)
      .subscribe((res: any) => {
        for (let key in res) {
          this.labels[key] = res[key];
        }

        this.configureDateOptions();
        this.setCasesDays();
      });
  }

  configureDateOptions() {
    let ranges = {};

    ranges[this.labels['Today']] = [moment(), moment()];
    ranges[this.labels['Yesterday']] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
    ranges[this.labels['Last 7 Days']] = [moment().subtract(6, 'days'), moment()];
    ranges[this.labels['Last 30 Days']] = [moment().subtract(29, 'days'), moment()];
    ranges[this.labels['This Month']] = [moment().startOf('month'), moment().endOf('month')];
    ranges[this.labels['Last Month']] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];

    this.dateoption = {
      ranges: ranges,
      locale: {
        'format': 'DD/MM/YYYY',
        'applyLabel': this.labels['Apply'],
        'cancelLabel': this.labels['Cancel'],
        'customRangeLabel': this.labels['Custom Range'],
        'daysOfWeek': [
          this.labels['Su'],
          this.labels['Mo'],
          this.labels['Tu'],
          this.labels['We'],
          this.labels['Th'],
          this.labels['Fr'],
          this.labels['Sa']
        ],
        'monthNames': [
          this.labels['January'],
          this.labels['February'],
          this.labels['March'],
          this.labels['April'],
          this.labels['May'],
          this.labels['June'],
          this.labels['July'],
          this.labels['August'],
          this.labels['September'],
          this.labels['October'],
          this.labels['November'],
          this.labels['December'],
        ]
      }
    };

    // 
  }

  getColors(total) {
    let lenBgColors = this.backgroundColors.length;
    if (this.backgroundColors == null || lenBgColors == 0) {
      return [];
    }

    let colors = [];
    let currentIndex = 0;

    // If total is > total, repeat colors
    for (var i = 0; i < total; ++i) {
      if (currentIndex >= lenBgColors) {
        currentIndex -= lenBgColors;
      }

      colors.push(this.backgroundColors[currentIndex]);
      currentIndex++;
    }

    return colors;
  }

  setCasesDays() {
    this.case_weekdays = [];

    const date = new Date();

    const weekname = [];
    weekname[0] = this.labels['Su'];
    weekname[1] = this.labels['Mo'];
    weekname[2] = this.labels['Tu'];
    weekname[3] = this.labels['We'];
    weekname[4] = this.labels['Th'];
    weekname[5] = this.labels['Fr'];
    weekname[6] = this.labels['Sa'];

    let count = 0;
    while (count < 28) {
      const weekday = new Date(date.getTime() - 3600 * 24 * 1000 * count).getDay();
      this.case_weekdays.unshift([weekname[weekday]]); // for days of "Cases" graph
      count++;
    }
  }

  getColorsGtLt(keys) {
    let colors = [];
    for (var i = 0; i < keys.length; ++i) {
      let key = keys[i];
      if (key.includes('>')) {
        colors.push(this.red_color);
      }
      else if (key.includes('<')) {
        colors.push(this.green_color);
      }
      else {
        colors.push(this.neutral_color);
      }
    }

    return colors;
  }

  selectFormat(graph_id) {
    this.chart_format[graph_id] = !this.chart_format[graph_id];
  }

  date_to_str(date) {
    const date_str = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    return date_str;
  }

  setDownload_filter(graph) {
    let filter = {};
    if (graph === 'Service by Country' || graph === 'Services by Sponsor' ||
      graph === 'Services by Category' || graph === 'Services') {
      filter = _.cloneDeep(this.service_filter);
    } else if (graph === 'BCX Cabin' || graph === 'BCX Provider' ||
      graph === 'CES' || graph === 'NPS' || graph === 'Service Ratings') {
      filter = _.cloneDeep(this.experience_filter);
      filter['bcx_operator'] = 2;
    } else if (graph === 'Contactability') {
      filter = _.cloneDeep(this.experience_filter);
      filter['contact_data'] = 2;
    } else if (graph === 'Road Assistance') {
      filter = _.cloneDeep(this.attention_filter);
      filter['road_assistance'] = true;
    } else if (graph === 'Medical Assistance') {
      filter = _.cloneDeep(this.attention_filter);
      filter['medical_assistance'] = true;
    } else if (graph === 'Home Assistance') {
      filter = _.cloneDeep(this.attention_filter);
      filter['home_assistance'] = true;
    } else if (graph === 'Cases') {
      filter = _.cloneDeep(this.case_filter);
      filter['cases'] = true;
    }
    return filter;
  }
}
